import axios from "axios";

export const postCreateCbPortalSessionApi = (data: { customerId: string }) => {
    return axios.post(route("api.chargebee.createPortalSession"), data);
};

export const validateEmailApi = (email: string, apiKey: string) => {
    return axios.get(
        `https://emailvalidation.abstractapi.com/v1/?api_key=${apiKey}&email=${email}`
    );
};
export const verifyChangeEmailPinApi = (pinCode: string, NewEmail: string) => {
    return axios.post(route("parents.verify-change-email-pin"), {
        pin: pinCode,
        email: NewEmail
    });
};

export const changeEmailRequestApi = (newEmail: string) => {
    return axios.post(route("parents.change-email-submit"), {
        email: newEmail
    });
};

export const cancelProgramApi = (data: {
    type: "addon" | "plan";
    licenseId?: number;
    itemId?: number;
    studentId: number;
    reasonId: number | null;
    cancellationType: "refund" | "non-refund";
}) => {
    return axios.post(route("api.subscription.cancel"), data);
};

export const cancelInstalmentProgramEarlyApi = (data: {
    licenseId: number;
    reasonId: number | null;
}) => {
    return axios.post(route("api.subscription.cancelInstallmentEarly"), data);
};

export const manageRegistrationsApi = (studentId: number) => {
    return axios.get(route("parents.manage-registrations", studentId));
};

export const resolveNotificationsApi = (data: {
    notificationIds: number[];
}) => {
    return axios.post(route("notifications.resolve"), data);
};

export const updateStudentsLocationApi = (
    data: {
        studentId: number;
        state: string;
    }[],
    parentId: number
) => {
    return axios.post(route("parent.update-student", parentId), {
        states: data
    });
};
